import { BaseField } from './BaseField';
import { boxSelectRenderer } from './fieldRenderers/boxFieldRenderer';
import { useSyncValues } from './hooks/useAutoSelectForDataFields';
import { useStateMachineForFields } from './hooks/useStateMachineForFields';
import { jsx as _jsx } from "react/jsx-runtime";
export function QuestionnaireBoxSelect(_ref) {
  let {
    columnClassName = 'col-6',
    name,
    label,
    answers,
    mktSelector = {
      value: label,
      group: false
    },
    isHiddenField,
    onFieldEnabled,
    onChange,
    renderFieldWrapper,
    ...props
  } = _ref;
  const {
    isFieldEnabled,
    sendUserSelect,
    stateFieldClassNames
  } = useStateMachineForFields({
    name
  });
  const options = answers.map(_ref2 => {
    let {
      value,
      label
    } = _ref2;
    return {
      value,
      label
    };
  });
  useSyncValues(name);
  return /*#__PURE__*/_jsx(BaseField, {
    label: label,
    name: name,
    MktSelector: mktSelector,
    topContainerClassName: stateFieldClassNames,
    disabled: !isFieldEnabled,
    renderFieldWrapper: renderFieldWrapper,
    isHiddenField: isHiddenField,
    onFieldEnabled: onFieldEnabled,
    renderFieldComponent: function fieldRenderer(_ref3) {
      let {
        name,
        mktSelector
      } = _ref3;
      return boxSelectRenderer({
        name,
        mktSelector,
        columnClassName,
        options,
        disabled: !isFieldEnabled,
        onChange(value) {
          onChange === null || onChange === void 0 || onChange(value);
          sendUserSelect(value);
        }
      });
    },
    ...props
  });
}